import { atom } from "recoil";


const PreviousFlightListAtom = atom({
    default: [],
    key: 'previousFlightList'
})

export default PreviousFlightListAtom;